import { Link } from 'react-router-dom';

export default function ProcessTimeline() {
  const steps = [
    {
      number: '01',
      title: 'Free Consultation',
      description: 'We assess your property and discuss your goals to create a customized plan',
      icon: 'ri-chat-check-line'
    },
    {
      number: '02',
      title: 'Property Preparation',
      description: 'Professional staging, photography, and listing creation to attract guests',
      icon: 'ri-camera-line'
    },
    {
      number: '03',
      title: 'Launch & Optimize',
      description: 'Go live on Airbnb with dynamic pricing and continuous optimization',
      icon: 'ri-rocket-line'
    },
    {
      number: '04',
      title: 'Ongoing Management',
      description: 'We handle everything from guest communication to maintenance coordination',
      icon: 'ri-settings-3-line'
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            How It Works
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed px-4">
            Our proven 4-step process to transform your property into a profitable Airbnb
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-white p-6 sm:p-8 rounded-2xl border-2 border-gray-100 hover:border-[#FF6B6B] transition-all duration-300 hover:shadow-xl group"
            >
              {/* Step Number */}
              <div className="absolute -top-4 -left-4 w-12 h-12 sm:w-14 sm:h-14 bg-[#FF6B6B] rounded-xl flex items-center justify-center shadow-lg">
                <span className="text-white font-bold text-lg sm:text-xl">{step.number}</span>
              </div>

              {/* Icon */}
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-[#FF6B6B]/10 rounded-xl mb-4 sm:mb-6 group-hover:bg-[#FF6B6B] transition-all mt-4 sm:mt-6">
                <i className={`${step.icon} text-3xl sm:text-4xl text-[#FF6B6B] group-hover:text-white transition-all w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3">
                {step.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {step.description}
              </p>

              {/* Connector Line (hidden on mobile, shown on larger screens) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gray-200"></div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-10 sm:mt-12 md:mt-16">
          <Link
            to="/contact"
            className="inline-block bg-[#FF6B6B] text-white px-8 sm:px-10 py-4 sm:py-5 rounded-lg font-semibold text-base sm:text-lg hover:bg-[#ff5252] transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            Get Started Today
          </Link>
        </div>
      </div>
    </section>
  );
}
